import { Logo } from '@kanda-libs/ks-design-library';

import useHelpModal from 'components/HelpModal/useHelpModal';
import { MessageCircle } from 'lucide-react';

import LayoutV2Button from '../Button';

export interface LayoutV2HeaderProps {
  showHelp?: boolean;
}

const LayoutV2Header: React.FunctionComponent<LayoutV2HeaderProps> = function ({
  showHelp = true,
}) {
  const { showHelpModal } = useHelpModal();
  return (
    <div className="sticky top-0 px-4 py-3 md:py-4 lg:px-8 border-b border-neutral-300 bg-neutral-000 z-[9999]">
      <div className="flex flex-row w-full max-w-7xl justify-between mx-auto gap-x-6">
        <Logo className="my-auto hidden md:block" />
        <Logo className="my-auto block md:hidden" compact />
        {showHelp && (
          <div className="flex flex-row flex-wrap gap-x-4">
            {showHelp && (
              <LayoutV2Button
                id="kanda-help-chat"
                onClick={showHelpModal}
                height="40"
              >
                <MessageCircle size={16} strokeWidth={3} />
                <p className="text-14-22-em">Need Help?</p>
              </LayoutV2Button>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default LayoutV2Header;
